import { Icon } from "armstrong-react";
import React from "react";
import { Link } from "react-router";
import * as WebRoutes from "@travellocal/utils/webRoutes";

export class ContactUsCard extends React.Component<{}, {}> {
  public render() {
    return (
      <div className={`content-card contact-us`}>
        <Icon icon={Icon.Icomoon.bubble} />
        <div className="title">Can't find what you're looking for?</div>
        <p>We're happy to help! Send us a message and we'll see what we can do.</p>
        <Link className="link" to={WebRoutes.inspiration()} />
      </div>
    );
  }
}
